import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

export default function SkuflixShare2Icon(props) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        d="M3.23046 12.6882C2.98305 12.4579 2.85934 12.3427 2.81402 12.2056C2.77423 12.0853 2.77423 11.9537 2.81402 11.8334C2.85934 11.6964 2.98305 11.5812 3.23046 11.3508L11.8154 3.35765C12.2413 2.96111 12.4543 2.76284 12.6345 2.75798C12.7912 2.75376 12.9409 2.82853 13.0399 2.96051C13.1538 3.11236 13.1538 3.41702 13.1538 4.02634V8.75497C15.3173 9.1661 17.2974 10.3569 18.7688 12.1449C20.3731 14.0942 21.2605 16.6168 21.2617 19.2315V19.9052C20.1982 18.5136 18.8704 17.3881 17.3692 16.6058C16.0456 15.9161 14.6149 15.5075 13.1538 15.3999V20.0127C13.1538 20.622 13.1538 20.9267 13.0399 21.0786C12.9409 21.2105 12.7912 21.2853 12.6345 21.2811C12.4543 21.2762 12.2413 21.078 11.8154 20.6814L3.23046 12.6882Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
}
